export const FEATURED_CENTER_PLACEMENT = {
  HIDDEN: 'Hidden',
  STANDARD: 'Standard'
}
